import Navbar from "../components/Navbar";

const Header = () => {
  return (
    <header>
     <Navbar />
    </header>
  );
}

export default Header